<template>
  <IQOS :title="$t('schedule.menu_title')" :enabled="!!schedule">
    <ScheduleEdit v-model="schedule" :invalid="invalid" dark v-if="schedule" />

    <p class="iqos-comment qrw-paragraph-md mt-16" v-if="!schedule">
      {{
        $t("schedule.menu_text")
      }}
    </p>

    <template #actions>
      <IQOSToggle :value="!!schedule" @input="toggleSchedule" />
    </template>
  </IQOS>
</template>

<script>
import ScheduleEdit from "@/components/schedule/ScheduleEdit.vue";

function getEmptyDay() {
  return {
    workday: false,
    startHour: null,
    endHour: null,
    startMinute: null,
    endMinute: null,
  };
}

function getEmptySchedule() {
  return {
    enabled: true,
    mon: getEmptyDay(),
    tue: getEmptyDay(),
    wed: getEmptyDay(),
    thu: getEmptyDay(),
    fri: getEmptyDay(),
    sat: getEmptyDay(),
    sun: getEmptyDay(),
  };
}

export default {
  components: {
    ScheduleEdit,
  },
  data() {
    return {
      invalid: false
    }
  },
  methods: {
    toggleSchedule(v) {
      if (v) {
        this.schedule = getEmptySchedule();
      } else {
        this.schedule = null;
      }
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    schedule: {
      get() {
        return this.$store.state.menu.current.schedule;
      },
      set(v) {
       if (v) {
         const is_schedule_invalid = Object.values(v).find(
          (day) => {
            return (
              day.workday &&
              (day.startHour === null ||
              day.endHour === null ||
              day.startMinute === null ||
              day.endMinute === null)
            );
          }
        );

        console.log(is_schedule_invalid);

        if (!!is_schedule_invalid && this.schedule) {
          this.invalid = true;
          return;
        }
       }


        this.$store.commit("menu/setMenuSchedule", v ? {
          ...v,
          enabled: true
        } : v);
        this.$store.dispatch("menu/save");

        this.$store.dispatch("saveCafe");

        this.$store.dispatch("auditlog/write", {
          type: "menu_schedule",
          payload: {
            mode: "general",
            schedule: this.schedule,
          },
        });
      },
    },
  },
};
</script>

<style>
</style>
